module.exports = __webpack_public_path__ + "img/step-signal.9ca59ceb.svg";